const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.userData ? state.user.userData.name : null,
  userData: state => state.user.userData,
  userType: state => state.user.userData ? state.user.userData.type : null
}
export default getters